/// <amd-module name="Artifacts/Root/routing/Types" />

/**
 * This file contains route param interfaces.
 */

export interface IFeedParams {
  feedIdentifier: string;
}

export interface IPackageDetailsContainerRouteParams {
  packageName: string;
  version?: string;
  protocol: string;
}

export type IFeedSettingsParams = IFeedParams;

export interface IConnectToFeedParams extends IFeedParams {
  feedIdentifier: string;
  toolId?: string;
}
